import React, { useContext, useState } from 'react'
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import dashboardStyles from '../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import customAPIStyles from "../../../../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss";
import { Grid, ListItemIcon, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { contactChatbotAssignmentData } from '../../../../../../models/axiosModel';
import { formatDateAccordingToTimezoneUsingMoment, hasCustomRecipientManageAccess } from '../../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import deleteDoc from "../../../../../../assets/deleteDoc.svg";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GlobalDeletePopup from '../../../../../utility/globalDeletePopup/globalDeletePopup';
import agent from '../../../../../../services/api';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface CustomRecipientTableProps {
    contactChatbotData: contactChatbotAssignmentData[] | null,
    getmetaIntegrationList: () => Promise<void>,
} 

const CustomRecipientTable: React.FC<CustomRecipientTableProps> = (props) => { 

    const { contactChatbotData, getmetaIntegrationList } = props;
    const { userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const innerHeight = (window.innerHeight - 220);
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<number | null>(null); 

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [selectedContact, setSelectedContact] = useState<contactChatbotAssignmentData | null>(null);

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: number) => { 
        event.stopPropagation();
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setCurrentRowIndex(null);
        setAnchorEl(null);
    }; 

    const menuItem = [
        {
            label: "Remove",
            icon: <img alt="" src={deleteDoc} />,
            action: (contact: contactChatbotAssignmentData) => {
                setSelectedContact(contact);
                setShowDeleteConfirmation(true); 
            }
        }
    ]

    const handleRemoveContactAssignment = async () => {
        if(selectedContact){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await agent.deleteContactChatbotAssignment.delete(selectedContact.chatbot_id, selectedContact.contact_chatbot_assignment_id, selectedContact.contact_id);
            if(!(res.status)){
                handleError(res);
            } else {
                showSuccess("Custom Recipient Removed Successfully.")
                await getmetaIntegrationList(); // GET Call.
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    return (
        <>
            <TableContainer className={`${whatsAppCampaignStyles.campaignTableContainer}`} sx={{maxHeight: `${innerHeight}px !important`}}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Contact List Name</TableCell>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Contact Phone Number</TableCell>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Assigned Chatbot</TableCell>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Timestamp</TableCell>
                            {hasCustomRecipientManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${customAPIStyles.lastColumnSticky} ${customAPIStyles.tableHeaderMorevertCell}`}></TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(contactChatbotData && contactChatbotData.length > 0) ?
                            contactChatbotData.map((contact: contactChatbotAssignmentData, index: number) => {
                                return (
                                    <TableRow className={dashboardStyles.cellRow} key={index}>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{contact.contact_list_name}</TableCell>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{contact.contact_phone_number}</TableCell>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                            <Grid item className={`${customAPIStyles.chatbotNameChip} ${globalStyles.clickable}`} onClick={() => window.open(`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${contact.chatbot_id}`, "_blank")}>
                                                {contact.chatbot_name}
                                            </Grid>
                                        </TableCell>
                                        <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{formatDateAccordingToTimezoneUsingMoment(contact.timestamp, userDetail.timezone_hour)}</TableCell>
                                        {hasCustomRecipientManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                            <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${customAPIStyles.lastColumnSticky} ${customAPIStyles.moreVertIcon}`}>
                                                <MoreVertIcon
                                                    className={`${globalStyles.clickable}`}
                                                    onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e, contact.contact_chatbot_assignment_id)}
                                                />
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    keepMounted
                                                    open={Boolean(anchorEl) && contact.contact_chatbot_assignment_id === currentRowIndex}
                                                    onClose={handleMenuClose}
                                                >
                                                    {menuItem.map((item, index) => {
                                                        return (
                                                            <MenuItem
                                                                className={`${globalStyles.menuItemStyle} ${globalStyles.secondaryFontSize}`}
                                                                key={index}
                                                                onClick={() => { handleMenuClose(); item.action(contact); }}
                                                            >
                                                                <ListItemIcon>
                                                                    {item.icon}
                                                                </ListItemIcon>
                                                                <span>
                                                                    {item.label}
                                                                </span>
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Menu>
                                            </TableCell>
                                        }
                                    </TableRow>
                                );
                            })
                            :
                            <TableRow className={dashboardStyles.cellRow}>
                                <TableCell colSpan={12} className={globalStyles.textCenter}>
                                    No Data Available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to remove the ${selectedContact?.chatbot_name} for ${selectedContact?.contact_phone_number} recipient`}
                    deleteNote="Once removed, this contact will be handled by the default chatbot assigned to this phone number."
                    open={showDeleteConfirmation}
                    onClose={() => setShowDeleteConfirmation(false)}
                    onDelete={() => {
                        if(selectedContact){
                            handleRemoveContactAssignment();
                        }
                        setShowDeleteConfirmation(false);
                    }}
                />
            } 
        </>
    )
}

export default CustomRecipientTable
